import type { ContractCreateRequest } from "@shared/types/contract";

export interface ValidationIssue {
  field: keyof ContractCreateRequest | "form";
  message: string;
}

export function validateContractCreate(
  input: ContractCreateRequest,
): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  if (!input.firm_id || input.firm_id.trim().length === 0) {
    issues.push({ field: "firm_id", message: "所属事務所を選択してください" });
  }
  if (!input.deal_name || input.deal_name.trim().length === 0) {
    issues.push({ field: "deal_name", message: "取引名を入力してください" });
  }
  for (const field of [
    "monthly_amount",
    "mrr_manual",
    "initial_amount",
    "annual_contract_amount",
    "proposed_acv",
    "proposed_mrr",
    "spot_amount",
  ] as const) {
    const value = input[field];
    if (value === null || value === undefined || value === "") continue;
    const n = Number(value);
    if (Number.isNaN(n) || n < 0) {
      issues.push({ field, message: "0以上の数値で入力してください" });
    }
  }
  if (input.renewal_likelihood_score) {
    const v = Number(input.renewal_likelihood_score);
    if (Number.isNaN(v) || v < 0 || v > 1) {
      issues.push({
        field: "renewal_likelihood_score",
        message: "更新確度は 0〜1 の範囲で指定してください",
      });
    }
  }
  return issues;
}
